<template>
    <div class="uk-form-controls">
        <textarea
            :name="name"
            :value="val"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            class="uk-textarea"
            :class="[{'uk-form-danger': errors.length}, width]"
            :rows="rows"
        >
        </textarea>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            val: {
                required: false,
                Type: String,
                default: ''
            },
            name: {
                required: true,
                Type: String
            },
            placeholder: {
                required: false,
                Type: String
            },
            label: {
                required: true,
                Type: String
            },
            rows: {
                required: false,
                Type: String,
                default: '5'
            },
            width: {
                required: false,
                type: String,
                default: 'uk-width-1-1'
            }
        },

        mounted() {
            if(this.val) {
                this.$emit('input', this.val)
            }
        }
    }
</script>